<!-- Display Mode -->
@if (!editMode) {
  <div
    fxLayout="column"
    class="box is-elevation-4">
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      class="tts-header">
      <div
        class="tts-header-number"
        fxLayout="row"
        fxLayoutAlign="center center">
        {{ index + 1 }}
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        class="ml-3">
        <i class="icon icon-small_bullhorn tts-header-icon"></i>
        <div class="tts-header-text">{{ 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-3' | translate }}</div>
      </div>
    </div>
    <div
      fxLayout="row"
      class="tts-body">
      <quill-view
        [content]="richTextOrPlaceHolder"
      format="html"></quill-view>
    </div>
  </div>
}

<!-- Edit Settings -->
@if (editMode) {
  <div>
    <div
      class="upload-edit-control"
      (click)="onEditClick()"
    style="
      margin: 4px;
      border: 3px dashed var(--neutral-color-400);
      background-color: var(--neutral-color-100);
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 100px;
    ">
      <div style="margin-right: 0.5rem">
        <i
          class="icon icon-text"
        style="font-size: 24px"></i>
      </div>
      <div>{{ 'COMMUNICATIONS.DESIGNER.ELEMENTS.TEXT-EDIT' | translate }}</div>
    </div>
  </div>
}

<topo-rich-text-edit
  [isActive]="showRichText"
  title="{{ 'COMMUNICATIONS.DESIGNER.MODIFY-CALL-TEXT' | translate }}"
  [value]="richTextValue"
  [backgroundCanClose]="false"
  (richTextUpdated)="updateRichText($event)"
  (cancelRichText)="cancelRichText()"
  [enableMentions]="true"
[mentionSearch]="getUserList.bind(this)"></topo-rich-text-edit>
